import React, { FC } from 'react';

import { useTranslation } from '@modernloop/i18n';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';

import { MAX_LOAD_LIMIT } from 'src/constants';

const ModuleLoadLimitOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, MAX_LOAD_LIMIT];

type Props = {
  selectedValue: number;
  onChange: (value: number) => void;
  disabled?: boolean;
};

/** Selects the weekly interview load limit for new module members. */
const LoadLimitSelect: FC<Props> = ({ selectedValue, onChange, disabled }) => {
  const { t } = useTranslation();

  return (
    <Select
      id="simple-load-limit-select"
      fullWidth
      value={String(selectedValue)}
      onChange={(event: SelectChangeEvent) => onChange(Number(event.target.value))}
      disabled={disabled}
    >
      {ModuleLoadLimitOptions.map((value) => (
        <MenuItem key={value} value={value}>
          {value === MAX_LOAD_LIMIT ? t('hiring-dashboard-interviewers:interviewers.moduleSetup.unlimited') : value}
        </MenuItem>
      ))}
    </Select>
  );
};

export default LoadLimitSelect;
